import { render, staticRenderFns } from "./ServiceTerritoriesCustom.vue?vue&type=template&id=13f9a8f4&"
import script from "./ServiceTerritoriesCustom.vue?vue&type=script&lang=js&"
export * from "./ServiceTerritoriesCustom.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTerritoriesCustom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports